import React from 'react';

const HowItCaptures = () => {
  return (
    <section className="w-full bg-[#0f1729] border-y border-border-dark">
      <div className="max-w-[1200px] mx-auto px-4 py-20 md:px-10">
        <div className="text-center mb-16">
          <h2 className="text-white text-3xl md:text-4xl font-bold mb-4">
            How UPI Trackr Analyzes Your Payments
          </h2>
          <p className="text-text-muted">Simply upload your UPI transaction statements and get instant insights into your spending.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          <div className="flex flex-col p-6 rounded-2xl bg-[#1a2332] border border-border-dark hover:border-primary/50 transition-colors">
            <div className="size-16 rounded-full bg-primary flex items-center justify-center mb-4">
              <span className="text-white text-2xl font-bold">1</span>
            </div>
            <h3 className="text-white text-lg font-bold mb-3">Export UPI Statement</h3>
            <p className="text-text-muted text-sm leading-relaxed">
              Request a UPI statement from your preferred payment app's customer support or download it from their website.
            </p>
          </div>
          <div className="flex flex-col p-6 rounded-2xl bg-[#1a2332] border border-border-dark hover:border-primary/50 transition-colors">
            <div className="size-16 rounded-full bg-primary flex items-center justify-center mb-4">
              <span className="text-white text-2xl font-bold">2</span>
            </div>
            <h3 className="text-white text-lg font-bold mb-3">Import PDF Securely</h3>
            <p className="text-text-muted text-sm leading-relaxed">
              Upload your PDF statements into UPI Trackr. We process the file locally on your device. No files are sent to any server.
            </p>
          </div>
          <div className="flex flex-col p-6 rounded-2xl bg-[#1a2332] border border-border-dark hover:border-primary/50 transition-colors">
            <div className="size-16 rounded-full bg-primary flex items-center justify-center mb-4">
              <span className="text-white text-2xl font-bold">3</span>
            </div>
            <h3 className="text-white text-lg font-bold mb-3">View Unified Insights</h3>
            <p className="text-text-muted text-sm leading-relaxed">
              Get an instant, consolidated breakdown of your spending across merchants, categories, and timelines in one place.
            </p>
          </div>
        </div>
        <div className="bg-[#2a2f45] rounded-2xl p-6 border border-border-dark flex items-start gap-4">
          <div className="size-12 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
            <span className="text-primary text-2xl">🔒</span>
          </div>
          <div>
            <h3 className="text-white text-lg font-bold mb-2">Privacy &amp; Transparency Callout</h3>
            <p className="text-text-muted text-sm leading-relaxed">
              UPI Trackr processes PDF statements locally on your device. Nothing is uploaded to our servers or shared with third parties.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItCaptures;
